import{b as t}from"./chunk-VTRYZJDB.mjs";import{theme as x}from"@refract-ui/core";var T=(s,e)=>{if(!e)return t.css``;let r=s.breakpointValues.reduce((n,a,p)=>{let i=s.breakpointNames[p],o=e==null?void 0:e[i];return o&&(a===0?n.push(t.css`
            ${(0,t.css)(...o)}
          `):n.push(t.css`
          @media screen and (min-width: ${a}px) {
            ${(0,t.css)(...o)}
          }
        `)),n},[]);return t.css`
    ${r}
  `},c=(s,e)=>{if(!e)return t.css``;let r=s.breakpointValues.reduce((n,a,p)=>{let i=s.breakpointNames[p],o=e==null?void 0:e[i];return o&&n.push(t.css`
        @media screen and (max-width: ${a-1}px) {
          ${(0,t.css)(...o)}
        }
      `),n},[]);return t.css`
    ${r}
  `},d=(s,e)=>{if(!e)return t.css``;let r=s.breakpointValues.reduce((n,a,p)=>{let i=s.breakpointNames[p],o=s.breakpointValues[p+1],m=e==null?void 0:e[i];if(m){let y=`min-width: ${a}px`;o&&(y+=`) and (max-width: ${o-1}px`),n.push(t.css`
        @media screen and (${y}) {
          ${(0,t.css)(...m)}
        }
      `)}return n},[]);return t.css`
    ${r}
  `},u=(s,e)=>{let r=T(s,e.up),n=c(s,e.down),a=d(s,e.only);return t.css`
    ${r}
    ${n}
    ${a}
  `};function O(s,e,r,n){return x(s,e,r,n,u)}export{O as theme};
